export const lang = {
  common: {
    success: 'success',
    LoginAndRegister: 'Login & Register',
    Terms: 'Terms',
    EditProfile: 'Edit Profile'
  },
  footer: {
    Home: 'Home',
    Training: 'Training',
    Invite: 'Invite',
    My: 'My'
  },
  route: {
    Home: 'Home',
    My: 'My information',
    Training: 'Training',
    Invite: 'Invite'
  },
  login: {
    training: 'AI Training & Rewards',
    welcome: 'Welcome to DataBox',
    mobile: 'Mobile Number',
    login: 'Log in / Sign up',
    check: 'Security Check',
    enter: 'enter here',
    enterOtp: 'Enter 4-Digit OTP',
    send: 'Send',
    resendText: 'Resend in ',
    tooOften: 'Please retry after {seconds}s',
    security: '256-bit SSL Encrypted · NPCI Partner Escrow Payouts',
    tip1: 'Instant Payouts',
    tip2: 'Daily UPI credit',
    tip3: 'Zero Passwords',
    tip4: '100% Secure OTP',
    agreement: [
      'By continuing, you agree to DataBox',
      'Terms of Service',
      'and',
      'Privacy Policy'
    ],
    invalid: 'Invalid Mobile Number',
    codeExpired: 'The code has expired',
    invalidCode: 'Invalid SNSCode',
    toast10002: 'Your account is restricted. Contact support for help.',
    toast10111: 'The current device login is restricted.',
    toast10122: 'The current device registration is restricted.'
  },
  account: {
    Account: 'Account',
    currencyType: 'BC'
  },
  my: {
    uid: 'UID:',
    bindTitle: 'Bind phone for security',
    bindDesc: 'Protect your account & withdrawals',
    bindPhone: 'Bind Phone >',
    availableBalance: 'available balance',
    walletHistory: 'Wallet History >',
    withdraw: 'Withdraw',
    fund: 'Add Funds',
    myTraining: 'My Training',
    activeTag: '1 Active',
    dailyProgress: 'Daily progress shared',
    continueBtn: 'Continue',
    inviteEarn: 'Invite & Earn',
    inviteDesc: 'Invite friends to earn more',
    notifications: 'Notifications',
    helpSupport: 'Help & Support',
    faqsTicket: 'FAQs & Ticket',
    withdrawAccount: 'Withdraw Account',
    bankDesc: 'Bank account for withdrawals',
    language: 'Language',
    englishIndia: 'English (India)',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    version: 'Version',
    versionNum: 'v2.4.0',
    logout: 'Log out'
  },
  terms: {
    title: [
      '1. Overview & Service Scope',
      '2. Account Eligibility & Security',
      '3. Task Evaluation & Verification',
      '4. Reward Formula & Settlement',
      '5. Principal Deposits & Safeguards',
      '6. Termination & Contact'
    ],
    paragraph: [
      'DataBox provides AI model calibration and task evaluation programs. Users participate in verification workflows and receive platform\n' +
      'Users must maintain one verified account bound via phone OTP. Users are responsible for all activities authenticated through their credentials. Multi-accounting, credential leasing, or spoofed proxy networks will trigger automated containment.',
      'Completed evaluation tasks are validated against dynamic quality thresholds. Systematic automated answering, bot farm generation, or fraudulent submissions will result in immediate disqualification and forfeiture of pending cycles.',
      'BC (Box Coins) are credited upon successful cycle verification according to stated program parameters. Conversion references (100 BC = ₹1) are indicative and governed by platform settlement rules, processing turnaround cadences, and network liquidity tiers.',
      'Deposit requirements for select training cohorts are securely held in escrow throughout the active cycle duration and returned upon scheduled cycle settlement, compliant with standard risk buffer protocols.',
      'violating integrity policies. For inquiries, contact support via Help & Support or direct your correspondence to {supportMail}.'
    ]
  },
  editInfo: {
    name: 'Name',
    uid: 'UID',
    permanentIdentifier: 'Permanent Identifier',
    copy: 'Copy',
    bindPhone: 'Bind Phone',
    bindForSecurity: 'Bind for security',
    phoneNumber: 'Phone Number',
    saveChanges: 'Save Changes',
    nameError: 'Please enter a name with 4-20 characters'
  },
  training: {
    rewardsTitle: "Claim today's free rewards",
    pro: 'Pro',
    claimAll: 'Claim all',
    myTraining: 'My Training',
    activeCount: '{count} Active',
    emptyText: 'No active programs, browse available programs',
    freeExperience: 'Free Experience',
    days: '{days} Days',
    deposit: 'Deposit {amount} BC',
    startFree: 'Start Free',
    availablePrograms: 'Available Programs',
    popular: 'Popular',
    earn: 'Earn {amount} BC',
    start: 'Start',
    timeMins: '~{mins} mins',
    programTitles: {
      p7d: 'Vision Model Training · 7 Days',
      p14d: 'Vision Model Training · 14 Days',
      p3d: 'AI Model Training · Starter · 3 Days'
    },
    discount: {
      firstTime: 'First time -10,000 BC !'
    }
  },
  progress: {
    title: 'Training Progress',
    dayOf: 'Day {cur} of {total}',
    progress: 'Progress',
    pctCompleted: '{pct}% Completed',
    lockedDeposit: 'Locked Deposit',
    amountBc: '{amount} BC',
    unlocksDay: 'Unlocks Day {day}',
    expectedYield: 'Expected Yield',
    atSettlement: 'At cycle settlement',
    dailySchedule: 'Daily Schedule',
    scheduleSub: 'Complete daily tasks to secure your cycle yield',
    today: 'Today',
    pct: '{pct}%',
    tasksCompleted: '{done}/{total} tasks completed',
    continue: 'Continue',
    dayName: 'Day {n}',
    settlementName: 'Day {n} · Cycle Settlement',
    unlocksAfter: 'Unlocks after Day {n}',
    locked: 'Locked',
    completed: 'Completed',
    notice: 'Missed a day? Complete catch-up tasks anytime before last day to protect your full yield.'
  },
  programDetail: {
    title: 'Program Detail',
    promoPrefix: 'First Special:',
    promoAmount: '-10,000 BC',
    promoSuffix: 'deposit discount',
    activeCycle: 'ACTIVE CYCLE',
    cycleSubtitle: 'Q&A Training Program (description here)',
    howItWorks: 'How It Works',
    simpleSteps: '3 SIMPLE STEPS',
    step1: 'Read the question',
    step2: 'Answer & Validate',
    step3: 'Reach daily target',
    noteShared: 'Daily progress shared across active Pros',
    specifications: 'Program Specifications',
    deposit: 'Deposit',
    duration: 'Duration',
    dailyTarget: 'Daily Target',
    rewardFormula: 'Reward Formula',
    upToBc: 'Up to {amount} BC',
    prorated: '(pro-rated by valid days)',
    principalProtection: 'Principal Protection',
    depositReturned: '100% Deposit returned',
    settlement: 'Settlement',
    durationValue: '7 Days',
    dailyTargetValue: '10 validations / day',
    settlementValue: 'Manual claim at the next day of cycle end',
    guaranteeTitle: 'Cycle Settlement Guarantee',
    guaranteeDesc: 'Principal and rewards unlock to your balance after end day. Deposit is 100% safeguarded and returned at cycle completion.',
    required: 'REQUIRED',
    discountApplied: '-10000 BC applied',
    depositLabel: 'Deposit {amount} BC',
    start: 'Start'
  },
  bindPhone: {
    title: 'Bind Phone',
    mobileNumber: 'Mobile Number',
    phoneError: 'Please enter a 10-digit number',
    enterOtp: 'Enter 4-Digit OTP',
    resend: 'Resend in {sec}s',
    send: 'Send',
    tooOften: 'Please retry after {seconds}s',
    invalidPhone: 'Invalid Mobile Number',
    invalidOtp: 'Please enter 4-digit OTP',
    autoFill: 'OTP code auto-filled via SMS',
    confirm: 'Confirm & Bind'
  },
  wallet: {
    title: 'Wallet',
    availableBalance: 'AVAILABLE BALANCE',
    approx: '≈ ₹{amount}',
    availableForPrograms: '{amount} BC available for programs',
    withdraw: 'Withdraw',
    addFunds: 'Add Funds',
    history: 'History',
    filterAll: 'All',
    filterAddFunds: 'Add Funds',
    filterWithdraw: 'Withdraw',
    filterRewards: 'Rewards',
    filterProgram: 'Program',
    statusDone: 'Done',
    statusProcessing: 'Processing',
    typeAddFunds: 'Add Funds',
    typeProgramLocked: 'Program Locked',
    typeWithdraw: 'Withdraw',
    typeWithdrawalFee: 'Withdrawal Fee',
    typeCheckIn: 'Check-in',
    typeProgramReturned: 'Program Returned',
    amountBc: '{sign}{amount} BC',
    loadMore: 'Pull up to load more'
  },
  invite: {
    referralProgram: 'REFERRAL PROGRAM',
    inviteFriendsEarn: 'Invite friends & earn',
    earnBc: 'Earn {amount} BC',
    whenFriendsAddFunds: 'when 3 friends complete a real Add Funds',
    shareInviteLink: 'Share invite link',
    copyLink: 'Copy link',
    inviteRewards: 'Invite Rewards',
    unlockBonuses: 'Unlock bonuses as friends become active',
    friendsTier: '{n} Friends',
    bonusBc: '+{amount} BC',
    claim: 'Claim',
    next: 'Next',
    moreNeeded: '{n} more needed',
    locked: 'Locked',
    toBeContinued: 'To be continued......',
    everyMoreFriends: 'Every {n} more friends',
    tierProgress: '{cur}/{total}',
    referralOverview: 'Referral Overview',
    viewInvitees: 'View Invitees',
    statInvited: 'Invited',
    statActive: 'Active',
    statBcEarned: 'BC Earned',
    activeDefinition: 'Active = completed a real Add Funds',
    howItWorks: 'How it works',
    step1Title: '1. Share your link',
    step1Desc: 'Send your invite link via WhatsApp or more.',
    step2Title: '2. Friends join and pay',
    step2Desc: 'They sign up and complete a real Add Funds.',
    step3Title: '3. Claim rewards',
    step3Desc: 'Claim your BC rewards to your balance.'
  }
}



// WEBPACK FOOTER //
// ./src/assets/locale/en-US.js